<template>
  <div class="mdc-checkbox-container" :class="{ 'mdc-checkbox-container--disabled': disabled }">
    <div class="mdc-checkbox" :class="{ 'mdc-checkbox--disabled': disabled }">
      <input
        type="checkbox"
        v-bind:id="id"
        v-bind:checked="state"
        v-on:change="onChange"
        class="mdc-checkbox__native-control"
        :disabled="disabled"
      />

      <div class="mdc-checkbox__background">
        <svg class="mdc-checkbox__checkmark"
             viewBox="0 0 24 24"
             v-if="!disabled">
          <path
            class="mdc-checkbox__checkmark__path"
            fill="none"
            stroke="white"
            d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
        </svg>

        <img src="/static/images/checkbox-disabled-btn.svg" v-else>

        <div class="mdc-checkbox__mixedmark"></div>
      </div>
    </div>
    <label v-bind:for="id" class="typography--caption typography--color-secondary clickable">
      <slot name="label"></slot>
    </label>
  </div>
</template>

<script>
  import { isArray } from 'lodash';

  export default {
    name: 'checkbox',

    props: [
      'id',
      'model-value',
      'check-value',
      'disabled',
    ],

    data() {
      return {
        isChecked: false,
      };
    },

    computed: {
      state() {
        if (isArray(this.modelValue)) {
          return this.modelValue.indexOf(this.checkValue) !== -1;
        }

        return this.modelValue === this.checkValue;
      },
    },

    methods: {
      check() {
        if (isArray(this.modelValue)) {
          const value = this.modelValue.slice(0);
          value.push(this.checkValue);

          return this.$emit('change', value);
        }

        return this.$emit('change', this.checkValue);
      },

      uncheck() {
        if (isArray(this.modelValue)) {
          const value = this.modelValue.slice(0);
          value.splice(value.indexOf(this.checkValue), 1);

          return this.$emit('change', value);
        }

        if (this.checkValue === true) {
          return this.$emit('change', false);
        }

        return this.$emit('change', null);
      },

      onChange() {
        if (this.state) {
          this.uncheck();
        } else {
          this.check();
        }
      },
    },
  };
</script>

<style lang="scss">
  .mdc-checkbox-container--disabled,
  .mdc-checkbox-container--disabled * {
    cursor: not-allowed !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Checkbox.vue